/**
 * src/api/impactoF1.js
 * La PUERTA del medidor de impacto F1 («sesión 0»). Solo LECTURA.
 *
 * 🔑 POR QUÉ ESTA LLAMADA EXISTE EN EL PANEL Y NO EN UN GUION. El rector del F1
 * manda medir M5-M7 contra la base real antes de construir, y resulta que NINGÚN
 * hilo puede consultar esa base: la Postgres no tiene proxy TCP y el servicio web
 * rechaza el CONNECT desde nuestros contenedores (medido el 31-10-2026). La medida
 * solo existe desde dentro de producción.
 * Y el endpoint, por sí solo, tampoco bastaba: pide `X-Admin-Token` o Bearer, así
 * que pegar su URL en el navegador da 401. Un instrumento que solo se puede leer
 * con una cabecera no está entregado (§10). De ahí esta llamada y su botón.
 *
 * Auth por JWT Bearer del usuario admin, como el resto del panel.
 */
import api from './client'

export const getSesionCeroDelImpacto = () =>
  api.get('/admin/panel/impacto/sesion-cero').then(r => r.data)
